import { Notification, NotificationAnalytics } from '@models/Notification'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { NOTIFICATIONS_URL } from '@utils/urls'

const fetchNotifications = (params: TableParams) =>
  SBAPI.FetchPaginated<Notification[]>(NOTIFICATIONS_URL, params)

const fetchNotificationById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Notification>(`${NOTIFICATIONS_URL}/${id}`, params)

const createNotification = (notification: Notification) =>
  SBAPI.Post(NOTIFICATIONS_URL, notification)

const sendNotification = (notification: Notification) =>
  SBAPI.Post(`${NOTIFICATIONS_URL}/${notification.id}/send`, notification)

const updateNotification = (notification: Notification) =>
  SBAPI.Put(`${NOTIFICATIONS_URL}/${notification.id}`, notification)

const deleteNotification = (notification: Notification) =>
  SBAPI.Delete(`${NOTIFICATIONS_URL}/${notification.id}`)

const fetchAnalyticsForNotification = (notification: Notification) =>
  SBAPI.Fetch<NotificationAnalytics>(
    `${NOTIFICATIONS_URL}/${notification.id}/analytics`
  )

export {
  createNotification,
  deleteNotification,
  fetchAnalyticsForNotification,
  fetchNotificationById,
  fetchNotifications,
  sendNotification,
  updateNotification,
}
